import { render, staticRenderFns } from "./city-select.vue?vue&type=template&id=1f982851&scoped=true&"
import script from "./city-select.vue?vue&type=script&lang=js&"
export * from "./city-select.vue?vue&type=script&lang=js&"
import style0 from "./city-select.vue?vue&type=style&index=0&id=1f982851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f982851",
  null
  
)

export default component.exports